// Action for resetting the entire Redux state
export const RESET_APP = "RESET_APP"
export const resetApp = () => ({ type: RESET_APP })
